import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Carousel from './Carousel';
import { MuiSkeletonVehicleTile } from './MUISkeletonVehicleTile';

export const RecommendationsPlaceholderCarousel: React.FC = () => {
    return (
        <div className="home-base-hero--tab-placeholder home-base-hero--recommandations-tab-placeholder carousel-container">
            <ul className="tab-placeholder--list">
                <Carousel
                    name="recommendations-placeholder"
                    nextFocus="#budget-calculator-section"
                    ariaLabel="No Recommendations Available"
                >
                    <li className="tab-placeholder--list-item carousel__slide" key="recommendations-placeholder-tile-1">
                        <Paper
                            sx={{
                                padding: { xs: 4, lg: 5 },
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            className="carousel-slide-item"
                        >
                            <Stack gap={3}>
                                <Stack>
                                    <Typography variant="h5" className="tab-placeholder--supportive-copy">
                                        Hmm… we’re having trouble loading this
                                    </Typography>
                                </Stack>
                                <Button color="primary" variant="outlined" size="medium" href="/">
                                    Try Reloading
                                </Button>
                            </Stack>
                        </Paper>
                    </li>
                    <li
                        className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                        key="recommendations-placeholder-tile-2"
                    >
                        <MuiSkeletonVehicleTile />
                    </li>
                    <li
                        className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                        key="recommendations-placeholder-tile-3"
                    >
                        <MuiSkeletonVehicleTile />
                    </li>
                    <li
                        className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                        key="recommendations-placeholder-tile-4"
                    >
                        <MuiSkeletonVehicleTile />
                    </li>
                </Carousel>
            </ul>
        </div>
    );
};
